import styled, { css } from 'styled-components';
import { darken, lighten } from 'polished';
import { Form as WebForm } from '@unform/web';
import FormControlLabel from '@mui/material/FormControlLabel';

const PRIMARY_GRADIENT =
  'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

/* tons por TIPO (mantém o significado das cores originais) */
const tipoTones = {
  1: {
    fg: '#2f7d52',
    bg: 'rgba(83, 128, 97, 0.12)',
    bd: 'rgba(83, 128, 97, 0.5)',
  },
  2: {
    fg: '#a87a12',
    bg: 'rgba(214, 167, 23, 0.14)',
    bd: 'rgba(214, 167, 23, 0.5)',
  },
  3: {
    fg: '#1f6fd6',
    bg: 'rgba(84, 133, 247, 0.12)',
    bd: 'rgba(84, 133, 247, 0.5)',
  },
  4: {
    fg: '#c0291c',
    bg: 'rgba(176, 24, 16, 0.1)',
    bd: 'rgba(176, 24, 16, 0.45)',
  },
  default: {
    fg: '#64748b',
    bg: 'rgba(148, 163, 184, 0.12)',
    bd: 'rgba(148, 163, 184, 0.5)',
  },
};

const situacaoTones = {
  1: {
    fg: '#a87a12',
    bg: 'rgba(214, 167, 23, 0.14)',
    bd: 'rgba(214, 167, 23, 0.5)',
  },
  2: {
    fg: '#2f7d52',
    bg: 'rgba(83, 128, 97, 0.12)',
    bd: 'rgba(83, 128, 97, 0.5)',
  },
  default: {
    fg: '#64748b',
    bg: 'rgba(148, 163, 184, 0.12)',
    bd: 'rgba(148, 163, 184, 0.5)',
  },
};

const handleCorTipo = (id) => tipoTones[id] || tipoTones.default;
const handleCorSituacao = (id) => situacaoTones[id] || situacaoTones.default;

/* rótulo padrão (uppercase, peso forte) reaproveitado nos wrappers */
const fieldLabel = css`
  display: block;
  width: 100%;
  margin-bottom: 7px;
  text-align: left;
  color: #4a5b72;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
`;

const fieldError = css`
  padding-top: 4px;
  color: #de3b3b;
  font-size: 11px;
  font-weight: 800;
`;

const fieldInput = css`
  display: block;
  width: 100%;
  height: 46px;
  padding: 0 14px;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 12px;
  background: #f8fafc;
  color: #1f2f46;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &::placeholder {
    color: #98a5b7;
    font-size: 14px;
  }

  &:hover:not(:focus):not(:disabled) {
    border-color: rgba(255, 109, 60, 0.4);
    background: #fff;
  }

  &:focus {
    border-color: #ff6d3c;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(255, 109, 60, 0.12);
  }

  &.has-error {
    border-color: #de3b3b;
    box-shadow: 0 0 0 4px rgba(222, 59, 59, 0.1);
  }

  &:disabled {
    background: #f1f5f9;
    color: #5b6b82;
  }
`;

// const handleCorTipo = (id) => {
//   switch (id) {
//     case 1:
//       return 'rgba(83,128,97,.9)';
//     case 2:
//       return 'rgba(230,222,42,.9)';
//     case 3:
//       return 'rgba(84,133,247,.9)';
//     case 4:
//       return 'rgba(176,24,16,.9)';
//     default:
//       return 'rgba(204,204,204,.9)';
//   }
// };

// const handleCorSituacao = (id) => {
//   switch (id) {
//     case 1:
//       return 'rgba(230,222,42,.9)';
//     case 2:
//       return 'rgba(83,128,97,.9)';
//     default:
//       return 'rgba(204,204,204,.9)';
//   }
// };

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* padding: 20px 0; */
  height: 100%;
  width: 100%;
  /* max-height: inherit; */
  max-width: ${(props) => (props.width ? `${props.width}px` : '1600px')};
  overflow-y: auto;
  margin: 0 auto;
  padding: 20px;

  ${(props) =>
    props.withBorder &&
    css`
      box-shadow: 0px 0px 10px #00000033;
      border-radius: 10px;
      background: #fff;
      margin: 34px auto;
      padding: 40px 60px;
      height: auto;
    `}
`;

// export const Form = styled(WebForm)`
//   /* flex: 1; */
//   width: 100%;
//   display: flex;
//   flex-direction: ${(props) => (props.row ? 'row' : 'column')};
//   justify-content: center;
//   /* height: 100%; */

//   h3 {
//     padding: 5px 0 10px;
//   }

//   & > footer {
//     display: flex;
//     justify-self: flex-end;
//     border-top: 1px solid #dbe1e9;
//     padding-top: 10px;
//     margin-top: 20px;

//     align-items: center;
//     justify-content: flex-end;

//     & > button {
//       /* border: 1px solid #ccc; */
//       border-radius: 5px;
//       padding: 10px 20px;
//       font-size: 16px;
//       margin-top: 10px;
//       min-width: 150px;
//       width: 150px;
//       background: none;
//       border: none;
//       color: #a0a9b9;

//       &:hover {
//         color: ${darken(0.05, '#a0a9b9')};
//       }

//       & + button {
//         margin-left: 10px;
//       }
//     }
//   }
// `;

export const Form = styled(WebForm)`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.row ? 'row' : 'column')};
  justify-content: center;

  h3 {
    padding: 5px 0 10px;
    color: #17263b;
    letter-spacing: -0.2px;
  }

  & > footer {
    display: flex;
    justify-self: flex-end;
    align-items: center;
    justify-content: flex-end;
    margin-top: 22px;
    padding-top: 14px;
    border-top: 1px solid rgba(216, 224, 235, 0.9);

    & > button {
      min-width: 150px;
      width: 150px;
      margin-top: 10px;
      padding: 11px 20px;
      border: none;
      border-radius: 12px;
      background: none;
      color: #a0a9b9;
      font-size: 15px;
      font-weight: 700;
      cursor: pointer;
      transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,
        transform 0.2s ease, filter 0.2s ease;

      &:hover {
        color: ${darken(0.05, '#a0a9b9')};
      }

      & + button {
        margin-left: 10px;
      }
    }
  }
`;

// Form.Title = styled.h1`
//   flex: 1;
//   font-size: 22px;

//   padding: 10px 0 15px;
// `;

// Form.Detail = styled.div`
//   display: flex;
//   flex-direction: column;
//   background: #ffffff;
//   border: 1px solid #dbe1e9;
//   border-radius: 5px;
//   padding: 20px 30px;
// `;

// Form.Separate = styled.div`
//   border-bottom: 1px solid #dbe1e9;
//   min-height: ${(props) => (props.height ? `${props.height}px` : `1px`)};

//   ${(props) =>
//     props.withFlex &&
//     css`
//       flex: 1;
//     `}
// `;

// Form.Row = styled.div`
//   flex: 1;
//   display: flex;
//   justify-content: flex-start;
//   align-items: flex-start;
//   border: 0;
//   padding: 0;
//   margin: 0;

//   @media (max-width: 600px) {
//     flex-direction: row;
//     align-items: stretch;
//   }

//   ${(props) =>
//     props.justifyCenter &&
//     css`
//       justify-content: space-evenly;
//     `}

//   ${(props) =>
//     props.justifyBetween &&
//     css`
//       justify-content: space-between;
//     `}

//   ${(props) =>
//     props.justifyEnd &&
//     css`
//       justify-content: flex-end;
//     `}

//   ${(props) =>
//     props.alignCenter &&
//     css`
//       align-items: center;
//     `}

//   ${(props) =>
//     props.alignEnd &&
//     css`
//       align-items: flex-end;
//     `}

//   ${(props) =>
//     props.withBorder &&
//     css`
//       border-top: 1px solid #dbe1e9;
//       padding-top: 10px;
//       margin-top: 10px;
//     `}

//   & > div {
//     padding: 5px;

//     @media (max-width: 600px) {
//       padding: 5px 0 0 0;
//     }

//     :first-child {
//       padding-left: 0;
//     }

//     :last-child {
//       padding-right: 0;
//     }
//   }

//   &#tipoPagina {
//     justify-content: end;
//   }
// `;

// Form.Column = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 100%;

//   ${(props) =>
//     props.justifyCenter &&
//     css`
//       justify-content: space-evenly;
//     `}

//   ${(props) =>
//     props.justifyEnd &&
//     css`
//       justify-content: flex-end;
//     `}

//   ${(props) =>
//     props.alignCenter &&
//     css`
//       align-items: center;
//     `}

//   ${(props) =>
//     props.alignEnd &&
//     css`
//       align-items: flex-end;
//     `}

//   ${(props) =>
//     props.withPadding &&
//     css`
//       padding: 10px;
//     `}

//   ${(props) =>
//     props.withBorder &&
//     css`
//       border-top: 1px solid #dbe1e9;
//       padding-top: 10px;
//       margin-top: 10px;
//     `}
// `;

// Form.Row.PageType = styled.span`
//   border-radius: 5px;
//   padding: 5px 10px;
//   text-align: center;
//   font-weight: bold;
//   width: 100px;
//   min-width: 100px;

//   ${({ type }) =>
//     type &&
//     css`
//       color: ${handleCorTipo(type)};
//       border: 2px solid ${handleCorTipo(type)};
//     `}

//   & + span {
//     margin-left: 5px;
//   }
// `;

// Form.Row.PageStatus = styled.span`
//   border-radius: 5px;
//   padding: 5px 10px;
//   text-align: center;
//   font-weight: bold;
//   width: 100px;
//   min-width: 100px;

//   ${({ status }) =>
//     status &&
//     css`
//       color: ${handleCorSituacao(status)};
//       border: 2px solid ${handleCorSituacao(status)};
//     `}

//   & + span {
//     margin-left: 5px;
//   }
// `;

// Form.Column.Kind = styled.span`
//   background: #dbe1e9;
//   border: 1px solid #dbe1e9;
//   border-radius: 5px;
//   color: #fff;
//   /* font-weight: bold; */
//   width: 100%;
//   padding: 5px 10px;

//   ${(props) =>
//     props.isAdded &&
//     css`
//       background: #538061;
//     `};

//   ${(props) =>
//     props.isRemoved &&
//     css`
//       background: #de3b3b;
//     `}

//   ${(props) =>
//     props.isPending &&
//     css`
//       background: #e6de2a;
//     `}
// `;

// Form.NotFound = styled.span`
//   display: block;
//   width: 100%;
//   text-align: center;

//   font-size: 14px;
//   font-style: italic;
//   color: rgba(44, 64, 90, 0.5);
//   padding: 40px 0;
// `;

// Form.Footer = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   align-items: flex-end;
//   padding: 10px 0 2px;

//   ${(props) =>
//     props.withStart &&
//     css`
//       justify-content: flex-start;
//     `}

//   ${(props) =>
//     props.withDirectNav &&
//     css`
//       justify-content: space-between;
//     `}

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: none;
//     border: 0;
//     border-radius: 5px;
//     min-height: 42px;
//     min-width: 150px;
//     color: #a0a9b9;
//     transition: all 1s;

//     & + button {
//       margin-left: 20px;
//     }

//     & > svg {
//       margin-right: 5px;
//     }

//     &#btn-submit {
//       color: #fff;
//       background: #ff6d3c;

//       &:hover {
//         background: ${darken(0.1, '#ff6d3c')};
//       }
//     }

//     &#btn-aprovar {
//       color: #fff;
//       background: #22c55e;
//       font-weight: bold;

//       &:hover {
//         background: ${darken(0.1, '#22c55e')};
//       }
//     }

//     &#btn-reprovar {
//       color: #fff;
//       background: #ff6d3c;
//       font-weight: bold;

//       &:hover {
//         background: ${darken(0.1, '#ff6d3c')};
//       }
//     }

//     &#btn-cancel {
//       &:hover {
//         color: ${darken(0.1, '#a0a9b9')};
//       }
//     }
//   }
// `;

// Form.Footer.Link = styled.button`
//   min-width: 20px !important;

//   :hover {
//     color: ${darken(0.05, '#1789dd')};
//   }
// `;

// Form.ControlWrapper = styled.div`
//   display: flex;
//   /* flex-direction: row; */
//   flex-direction: column;
//   flex-wrap: wrap;
//   justify-content: space-evenly;
//   width: 100%;
//   height: 100%;
// `;

// Form.CardWrapper = styled.div`
//   display: flex;
//   align-items: center;
// `;

// Form.ControlLabel = styled(FormControlLabel)`
//   flex: 1;
// `;

// Form.Grid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   column-gap: 10px;
//   row-gap: 15px;
// `;

Form.Title = styled.h1`
  flex: 1;
  padding: 10px 0 15px;
  color: #17263b;
  font-size: 22px;
  letter-spacing: -0.4px;
`;

Form.Detail = styled.div`
  display: flex;
  flex-direction: column;
  padding: 22px 30px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(23, 38, 59, 0.06),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;
`;

Form.Separate = styled.div`
  border-bottom: 1px solid rgba(216, 224, 235, 0.9);
  min-height: ${(props) => (props.height ? `${props.height}px` : `1px`)};

  ${(props) =>
    props.withFlex &&
    css`
      flex: 1;
    `}
`;

Form.Row = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  border: 0;
  padding: 0;
  margin: 0;

  @media (max-width: 600px) {
    flex-direction: row;
    align-items: stretch;
  }

  ${(props) =>
    props.justifyCenter &&
    css`
      justify-content: space-evenly;
    `}

  ${(props) =>
    props.justifyBetween &&
    css`
      justify-content: space-between;
    `}

  ${(props) =>
    props.justifyEnd &&
    css`
      justify-content: flex-end;
    `}

  ${(props) =>
    props.alignCenter &&
    css`
      align-items: center;
    `}

  ${(props) =>
    props.alignEnd &&
    css`
      align-items: flex-end;
    `}

  ${(props) =>
    props.withBorder &&
    css`
      border-top: 1px solid rgba(216, 224, 235, 0.9);
      padding-top: 10px;
      margin-top: 10px;
    `}

  & > div {
    padding: 5px;

    @media (max-width: 600px) {
      padding: 5px 0 0 0;
    }

    :first-child {
      padding-left: 0;
    }

    :last-child {
      padding-right: 0;
    }
  }

  &#tipoPagina {
    justify-content: end;
  }
`;

Form.Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props) =>
    props.justifyCenter &&
    css`
      justify-content: space-evenly;
    `}

  ${(props) =>
    props.justifyEnd &&
    css`
      justify-content: flex-end;
    `}

  ${(props) =>
    props.alignCenter &&
    css`
      align-items: center;
    `}

  ${(props) =>
    props.alignEnd &&
    css`
      align-items: flex-end;
    `}

  ${(props) =>
    props.withPadding &&
    css`
      padding: 10px;
    `}

  ${(props) =>
    props.withBorder &&
    css`
      border-top: 1px solid rgba(216, 224, 235, 0.9);
      padding-top: 10px;
      margin-top: 10px;
    `}
`;

Form.Row.PageType = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 6px 12px;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.3px;
  width: 100px;
  min-width: 100px;

  ${({ type }) => {
    if (!type) return null;
    const tone = handleCorTipo(type);
    return css`
      color: ${tone.fg};
      background: ${tone.bg};
      border: 1px solid ${tone.bd};
    `;
  }}

  & + span {
    margin-left: 6px;
  }
`;

Form.Row.PageStatus = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 6px 12px;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.3px;
  width: 100px;
  min-width: 100px;

  ${({ status }) => {
    if (!status) return null;
    const tone = handleCorSituacao(status);
    return css`
      color: ${tone.fg};
      background: ${tone.bg};
      border: 1px solid ${tone.bd};
    `;
  }}

  & + span {
    margin-left: 6px;
  }
`;

Form.Column.Kind = styled.span`
  width: 100%;
  padding: 6px 12px;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 10px;
  background: #e2e8f0;
  color: #fff;
  font-size: 13px;
  font-weight: 700;

  ${(props) =>
    props.isAdded &&
    css`
      background: #538061;
      border-color: #538061;
    `};

  ${(props) =>
    props.isRemoved &&
    css`
      background: #de3b3b;
      border-color: #de3b3b;
    `}

  ${(props) =>
    props.isPending &&
    css`
      background: #d6a017;
      border-color: #d6a017;
    `}
`;

Form.NotFound = styled.span`
  display: block;
  width: 100%;
  padding: 40px 0;
  text-align: center;
  color: rgba(44, 64, 90, 0.5);
  font-size: 14px;
  font-style: italic;
`;

Form.Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 10px 0 2px;

  ${(props) =>
    props.withStart &&
    css`
      justify-content: flex-start;
    `}

  ${(props) =>
    props.withDirectNav &&
    css`
      justify-content: space-between;
    `}

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 46px;
    min-width: 150px;
    border: 0;
    border-radius: 12px;
    background: none;
    color: #a0a9b9;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,
      transform 0.2s ease, filter 0.2s ease;

    & + button {
      margin-left: 20px;
    }

    & > svg {
      margin-right: 5px;
    }

    &#btn-submit {
      color: #fff;
      background: ${PRIMARY_GRADIENT};
      box-shadow: 0 12px 26px rgba(255, 109, 60, 0.32);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
        filter: brightness(1.02);
      }
    }

    &#btn-aprovar {
      color: #fff;
      background: linear-gradient(135deg, #22c55e 0%, #2bd66b 100%);
      box-shadow: 0 12px 26px rgba(34, 197, 94, 0.3);
      font-weight: 800;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 32px rgba(34, 197, 94, 0.4);
        filter: brightness(1.02);
      }
    }

    &#btn-reprovar {
      color: #fff;
      background: ${PRIMARY_GRADIENT};
      box-shadow: 0 12px 26px rgba(255, 109, 60, 0.32);
      font-weight: 800;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
        filter: brightness(1.02);
      }
    }

    &#btn-cancel {
      &:hover {
        color: ${darken(0.1, '#a0a9b9')};
        background: rgba(160, 169, 185, 0.12);
      }
    }
  }
`;

Form.Footer.Link = styled.button`
  min-width: 20px !important;
  border-radius: 10px;
  transition: color 0.2s ease, background 0.2s ease;

  :hover {
    color: ${darken(0.05, '#1789dd')};
  }
`;

Form.ControlWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  height: 100%;
`;

Form.CardWrapper = styled.div`
  display: flex;
  align-items: center;
`;

Form.ControlLabel = styled(FormControlLabel)`
  flex: 1;
`;

Form.Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 10px;
  row-gap: 15px;
`;

// export const Row = styled.div`
//   flex: 1;
//   display: flex;

//   /** Adiciona borda */
//   border-top: ${(props) => (props.borderTop ? '1px solid #dbe1e9' : '0')};
//   padding-top: ${(props) => (props.borderTop ? '10px' : '0')};
//   margin-top: ${(props) => (props.borderTop ? '10px' : '0')};

//   justify-content: ${(props) => (props.alignEnd ? 'flex-end' : 'flex-start')};
//   align-items: ${(props) => (props.alingItens ? 'center' : 'flex-start')};

//   & > div {
//     padding: 10px 20px;

//     &:first-child {
//       padding-left: 0;
//     }

//     &:last-child {
//       padding-right: 0;
//     }
//   }

//   & > span {
//     margin-left: -10px;
//     color: #444;
//   }

//   ${(props) =>
//     props.customPagination &&
//     css`
//       align-items: center;

//       & > div {
//         padding: 0 20px;
//       }
//     `}
// `;

export const Row = styled.div`
  flex: 1;
  display: flex;

  /** Adiciona borda */
  border-top: ${(props) =>
    props.borderTop ? '1px solid rgba(216, 224, 235, 0.9)' : '0'};
  padding-top: ${(props) => (props.borderTop ? '10px' : '0')};
  margin-top: ${(props) => (props.borderTop ? '10px' : '0')};

  justify-content: ${(props) => (props.alignEnd ? 'flex-end' : 'flex-start')};
  align-items: ${(props) => (props.alingItens ? 'center' : 'flex-start')};

  & > div {
    padding: 10px 20px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  & > span {
    margin-left: -10px;
    color: #4a5b72;
  }

  ${(props) =>
    props.customPagination &&
    css`
      align-items: center;

      & > div {
        padding: 0 20px;
      }
    `}
`;

// export const Column = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   width: auto;
//   /* width: fit-content; */

//   /** Adiciona borda */
//   border-top: ${(props) => (props.borderTop ? '1px solid #dbe1e9' : '0')};
//   padding-top: ${(props) => (props.borderTop ? '10px' : '0')};
//   margin-top: ${(props) => (props.borderTop ? '10px' : '0')};
// `;

export const Column = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: auto;

  /** Adiciona borda */
  border-top: ${(props) =>
    props.borderTop ? '1px solid rgba(216, 224, 235, 0.9)' : '0'};
  padding-top: ${(props) => (props.borderTop ? '10px' : '0')};
  margin-top: ${(props) => (props.borderTop ? '10px' : '0')};
`;

// export const RowFooter = styled.div`
//   display: flex;
//   align-items: flex-end;
//   justify-content: ${(props) => (props.alignStart ? 'flex-start' : 'flex-end')};
//   margin-top: 30px;
//   padding: 20px 0;
//   border-top: 1px solid #dbe1e9;

//   #btn-submit {
//     color: #fff;
//     background: #ff6d3c;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     border: none;
//     border-radius: 5px;
//     min-height: 42px;
//     min-width: 150px;

//     & + button {
//       margin-left: 10px;
//     }

//     & > svg {
//       margin-right: 5px;
//     }

//     &:hover {
//       background: ${darken(0.05, '#ff6d3c')};
//     }
//   }

//   #btn-cancel {
//     background: none;
//     border: none;
//     color: #a0a9b9;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     border: none;
//     border-radius: 5px;
//     min-height: 42px;
//     min-width: 150px;

//     & + button {
//       margin-left: 10px;
//     }

//     & > svg {
//       margin-right: 5px;
//     }

//     &:hover {
//       color: ${darken(0.05, '#a0a9b9')};
//     }
//   }
// `;

export const RowFooter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: ${(props) => (props.alignStart ? 'flex-start' : 'flex-end')};
  margin-top: 30px;
  padding: 20px 0;
  border-top: 1px solid rgba(216, 224, 235, 0.9);

  #btn-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 46px;
    min-width: 150px;
    border: none;
    border-radius: 12px;
    color: #fff;
    font-weight: 800;
    cursor: pointer;
    background: ${PRIMARY_GRADIENT};
    box-shadow: 0 12px 26px rgba(255, 109, 60, 0.32);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

    & + button {
      margin-left: 10px;
    }

    & > svg {
      margin-right: 5px;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
      filter: brightness(1.02);
    }
  }

  #btn-cancel {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 46px;
    min-width: 150px;
    border: none;
    border-radius: 12px;
    background: none;
    color: #a0a9b9;
    font-weight: 700;
    cursor: pointer;
    transition: color 0.2s ease, background 0.2s ease;

    & + button {
      margin-left: 10px;
    }

    & > svg {
      margin-right: 5px;
    }

    &:hover {
      color: ${darken(0.05, '#a0a9b9')};
      background: rgba(160, 169, 185, 0.12);
    }
  }
`;

// export const LinkButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: none;
//   border: none;
//   color: #1789dd;
//   padding: 10px 20px;
//   min-width: 120px;
//   transition: color 1s;

//   & + button {
//     margin-left: 5px;
//   }

//   :hover {
//     color: ${darken(0.05, '#1789dd')};
//   }

//   > svg {
//     margin-right: 5px;
//   }
// `;

export const LinkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  background: none;
  color: #1789dd;
  font-weight: 700;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease;

  & + button {
    margin-left: 5px;
  }

  :hover {
    color: ${darken(0.05, '#1789dd')};
    background: rgba(23, 137, 221, 0.08);
  }

  > svg {
    margin-right: 5px;
  }
`;

// export const ModeloButton = styled.button`
//   display: flex;
//   flex: 1;
//   align-items: center;
//   justify-content: center;
//   background: transparent;
//   border: 1px solid #a0a9b9;
//   color: #a0a9b9;
//   border-radius: 5px;
//   padding: 10px 20px;
//   min-width: 120px;
//   transition: all 0.3s;

//   :hover {
//     color: #fff;
//     border-color: #1789dd;
//     background: ${lighten(0.08, '#1789dd')};
//   }

//   > svg {
//     margin-right: 5px;
//   }
// `;

export const ModeloButton = styled.button`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 10px 20px;
  border: 1px solid #a0a9b9;
  border-radius: 12px;
  background: transparent;
  color: #a0a9b9;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s ease;

  :hover {
    color: #fff;
    border-color: #1789dd;
    background: ${lighten(0.08, '#1789dd')};
    box-shadow: 0 12px 26px rgba(23, 137, 221, 0.28);
    transform: translateY(-1px);
  }

  > svg {
    margin-right: 5px;
  }
`;

// export const InputWrapper = styled.div`
//   display: ${(props) => (props.isHidden ? 'none' : 'flex')};
//   flex-direction: ${(props) => props.flexDirection};
//   padding: 5px 0;
//   width: ${(props) => (props.width ? `${props.width}px` : '100%')};
//   max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};

//   @media (max-width: 600px) {
//     font-size: 10px;
//     width: 100%;
//     max-width: 100%;
//   }

//   ${(props) =>
//     props.height &&
//     css`
//       height: ${props.height}px;
//     `}

//   label {
//     display: block;
//     text-align: left;
//     margin-bottom: 5px;
//     color: #444;
//     font-size: 14px;
//     font-weight: bold;
//     text-transform: uppercase;
//     width: 100%;
//   }

//   input {
//     display: block;
//     border: ${(props) => (props.custom ? 'none' : '1px solid #cbd0d8')};
//     border-radius: 5px;
//     color: #444;
//     font-size: 16px;
//     padding: 10px 15px;
//     width: 100%;

//     &::placeholder {
//       color: #79869e;
//       font-size: 14px;
//     }

//     &:disabled {
//       background: #f9fbff;
//     }
//   }

//   span.error {
//     font-size: 11px;
//     font-weight: bold;
//     color: #de3b3b;
//     padding-top: 2px;
//   }

//   ${(props) =>
//     props.customPagination &&
//     css`
//       input {
//         padding: 2px 15px;
//       }
//     `}
// `;

export const InputWrapper = styled.div`
  display: ${(props) => (props.isHidden ? 'none' : 'flex')};
  flex-direction: ${(props) => props.flexDirection};
  padding: 5px 0;
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};

  @media (max-width: 600px) {
    font-size: 10px;
    width: 100%;
    max-width: 100%;
  }

  ${(props) =>
    props.height &&
    css`
      height: ${props.height}px;
    `}

  label {
    display: block;
    width: 100%;
    margin-bottom: 7px;
    text-align: left;
    color: #4a5b72;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.6px;
    text-transform: uppercase;
  }

  /* aplica somente ao input nativo (filho direto), para não vazar
     nos componentes que renderizam estruturas próprias dentro do
     wrapper, como o react-select (Select) */
  & > input {
    display: block;
    width: 100%;
    height: 46px;
    padding: 0 14px;
    border: ${(props) =>
      props.custom ? 'none' : '1px solid rgba(216, 224, 235, 0.9)'};
    border-radius: 12px;
    background: #f8fafc;
    color: #1f2f46;
    font-size: 15px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease,
      background 0.2s ease;

    &::placeholder {
      color: #98a5b7;
      font-size: 14px;
    }

    &:hover:not(:focus):not(:disabled) {
      border-color: rgba(255, 109, 60, 0.4);
      background: #fff;
    }

    &:focus {
      border-color: #ff6d3c;
      background: #fff;
      box-shadow: 0 0 0 4px rgba(255, 109, 60, 0.12);
    }

    &.has-error {
      border-color: #de3b3b;
      box-shadow: 0 0 0 4px rgba(222, 59, 59, 0.1);
    }

    &:disabled {
      background: #f1f5f9;
      color: #5b6b82;
    }

    ${(props) =>
      props.custom &&
      css`
        height: auto;
        padding: 10px 15px;
        background: none;
        box-shadow: none;

        &:focus {
          box-shadow: none;
        }
      `}
  }

  span.error {
    padding-top: 4px;
    color: #de3b3b;
    font-size: 11px;
    font-weight: 800;
  }

  ${(props) =>
    props.customPagination &&
    css`
      & > input {
        height: auto;
        padding: 6px 15px;
        text-align: center;
      }
    `}
`;

// export const FileWrapper = styled.div`
//   align-self: center;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border: 1px dashed #cbd0d8;
//   border-radius: 5px;
//   padding: 10px 20px;
//   width: 100%;
//   max-width: 500px;
//   height: 100%;

//   ${(props) =>
//     props.withBackground &&
//     css`
//       background: url(${props.withBackground}) no-repeat center;
//       background-size: contain;
//     `}

//   > div {
//     display: flex;
//     flex-direction: column;
//     padding: 30px 20px;

//     text-align: center;

//     ${(props) =>
//       props.withBackground &&
//       css`
//         background: rgba(255, 255, 255, 0.8);
//         border-radius: 5px;
//       `}

//     > label {
//       margin: 10px auto 0;
//       text-align: center;
//       border-radius: 5px;
//       padding: 10px 20px;
//       background: #ff6d3c;
//       color: #fff;
//       font-weight: normal;
//       transition: background 1s;
//       max-width: 400px;

//       :hover {
//         background: ${darken(0.1, '#ff6d3c')};
//       }

//       > input[type='file'] {
//         display: none;
//       }
//     }
//   }
// `;

export const FileWrapper = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  height: 100%;
  padding: 10px 20px;
  border: 1.5px dashed rgba(216, 224, 235, 0.95);
  border-radius: 16px;
  background: #f8fafc;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: rgba(255, 109, 60, 0.5);
    background: #fff;
  }

  ${(props) =>
    props.withBackground &&
    css`
      background: url(${props.withBackground}) no-repeat center;
      background-size: contain;
    `}

  > div {
    display: flex;
    flex-direction: column;
    padding: 30px 20px;
    text-align: center;

    ${(props) =>
      props.withBackground &&
      css`
        background: rgba(255, 255, 255, 0.85);
        border-radius: 12px;
      `}

    > label {
      max-width: 400px;
      margin: 10px auto 0;
      padding: 11px 22px;
      border-radius: 12px;
      text-align: center;
      color: #fff;
      font-weight: 700;
      cursor: pointer;
      background: ${PRIMARY_GRADIENT};
      box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
      transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

      :hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 32px rgba(255, 109, 60, 0.4);
        filter: brightness(1.02);
      }

      > input[type='file'] {
        display: none;
      }
    }
  }
`;

// export const ImgFileWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   max-height: ${(props) => `${props.height}px`};
//   max-width: ${(props) => `${props.width}px`};

//   > img {
//     border: 1px dashed #cbd0d8;
//     padding: 5px;
//     object-fit: contain;
//     height: 100%;
//     width: 100%;
//   }
// `;

export const ImgFileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: ${(props) => `${props.height}px`};
  max-width: ${(props) => `${props.width}px`};

  > img {
    border: 1.5px dashed rgba(216, 224, 235, 0.95);
    border-radius: 12px;
    padding: 6px;
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
`;

// ImgFileWrapper.Control = styled.div`
//   display: flex;
//   padding-top: 5px;

//   > label {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     border-radius: 5px;
//     border: 1px solid #ff6d3c;
//     color: #ff6d3c;
//     transition: background 1s;
//     height: 25px;
//     width: 25px;

//     :hover {
//       background: ${darken(0.1, '#ff6d3c')};
//       color: #fff;
//     }

//     > input[type='file'] {
//       display: none;
//     }
//   }

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: none;
//     color: #cbd0d8;
//     border: 1px solid #cbd0d8;
//     border-radius: 5px;
//     margin-left: 5px;
//     transition: background 1s;
//     height: 25px;
//     width: 25px;

//     :hover {
//       background: ${darken(0.1, '#de3b3b')};
//       border: 1px solid #de3b3b;
//       color: #fff;
//     }
//   }
// `;

// ImgFileWrapper.Preview = styled.div`
//   display: flex;
//   position: relative;

//   > img {
//     height: auto;
//     width: 180px;
//   }

//   > button {
//     position: absolute;
//     right: 0;
//     top: 0;

//     background: none;
//     border: 0;
//   }
// `;

ImgFileWrapper.Control = styled.div`
  display: flex;
  padding-top: 6px;

  > label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
    border: 1px solid #ff6d3c;
    border-radius: 9px;
    color: #ff6d3c;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;

    :hover {
      background: #ff6d3c;
      color: #fff;
    }

    > input[type='file'] {
      display: none;
    }
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
    margin-left: 6px;
    border: 1px solid #cbd0d8;
    border-radius: 9px;
    background: none;
    color: #cbd0d8;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

    :hover {
      background: #de3b3b;
      border: 1px solid #de3b3b;
      color: #fff;
    }
  }
`;

ImgFileWrapper.Preview = styled.div`
  display: flex;
  position: relative;

  > img {
    height: auto;
    width: 180px;
    border-radius: 10px;
  }

  > button {
    position: absolute;
    right: 0;
    top: 0;
    background: none;
    border: 0;
    cursor: pointer;
  }
`;

// export const ViewerWrapper = styled.div`
//   display: ${(props) => (props.isHidden ? 'none' : 'flex')};
//   position: relative;
//   flex-direction: ${(props) => props.flexDirection};
//   padding: 10px 0;
//   width: 100%;
//   max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};

//   ${(props) =>
//     props.asRow &&
//     css`
//       align-items: center;
//       flex-direction: row;
//       width: auto;
//     `}

//   button.attach {
//     display: flex;
//     align-items: center;
//     border: 0;
//     background: none;
//     color: #0030cf;
//     text-align: left;
//     padding: 0;
//     transition: color 1s;

//     > span {
//       margin-left: 5px;
//       max-width: 180px;
//       width: 100%;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     :hover {
//       color: ${darken(0.05, '#0030cf')};
//       text-decoration: underline;
//     }
//   }

//   label {
//     display: block;
//     text-align: left;
//     margin-bottom: ${(props) => (props.strong ? '12px' : '5px')};

//     color: ${(props) => props.theme.colorRequestName};
//     font-size: 14px;
//     width: 100%;

//     ${(props) =>
//       props.asRow &&
//       css`
//         margin: 0;
//         width: 150px;
//       `}
//   }

//   input {
//     display: block;
//     border: none;
//     background: none;

//     color: ${(props) => props.theme.colorUserName};
//     font-size: ${(props) => (props.strong ? '20px' : '15px')};
//     font-weight: ${(props) => (props.strong ? 'bold' : 'normal')};
//     width: 100%;

//     ${(props) =>
//       props.asRow &&
//       css`
//         width: auto;
//       `}
//   }

//   textarea {
//     display: block;
//     border: none;
//     background: none;
//     color: #444;
//     font-size: 15px;
//     width: 100%;
//     resize: none;
//     white-space: pre-line;
//   }
// `;

export const ViewerWrapper = styled.div`
  display: ${(props) => (props.isHidden ? 'none' : 'flex')};
  position: relative;
  flex-direction: ${(props) => props.flexDirection};
  padding: 10px 0;
  width: 100%;
  max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};

  ${(props) =>
    props.asRow &&
    css`
      align-items: center;
      flex-direction: row;
      width: auto;
    `}

  button.attach {
    display: flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: none;
    color: #1789dd;
    font-weight: 700;
    text-align: left;
    cursor: pointer;
    transition: color 0.2s ease;

    > span {
      margin-left: 5px;
      max-width: 180px;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    :hover {
      color: ${darken(0.08, '#1789dd')};
      text-decoration: underline;
    }
  }

  label {
    display: block;
    width: 100%;
    margin-bottom: ${(props) => (props.strong ? '12px' : '6px')};
    text-align: left;
    color: ${(props) => props.theme.colorRequestName};
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.6px;
    text-transform: uppercase;

    ${(props) =>
      props.asRow &&
      css`
        margin: 0;
        width: 150px;
      `}
  }

  input {
    display: block;
    width: 100%;
    border: none;
    background: none;
    color: ${(props) => props.theme.colorUserName};
    font-size: ${(props) => (props.strong ? '20px' : '15px')};
    font-weight: ${(props) => (props.strong ? 'bold' : '500')};

    ${(props) =>
      props.asRow &&
      css`
        width: auto;
      `}
  }

  textarea {
    display: block;
    width: 100%;
    border: none;
    background: none;
    color: #2c405a;
    font-size: 15px;
    line-height: 1.55;
    resize: none;
    white-space: pre-line;
  }
`;

// export const CheckWrapper = styled.div`
//   padding: 10px 0;

//   label {
//     display: flex;
//     align-items: center;
//     color: #444;
//     font-size: 14px;
//     font-weight: bold;
//     text-transform: uppercase;

//     input {
//       margin-right: 5px;
//       color: #999;
//     }
//   }

//   span.error {
//     font-size: 11px;
//     font-weight: bold;
//     color: #de3b3b;
//     padding-top: 2px;
//   }
// `;

// export const TextAreaWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 10px 0;
//   width: 100%;
//   max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};

//   label {
//     display: block;
//     text-align: left;
//     margin-bottom: 5px;
//     color: #444;
//     font-size: 14px;
//     font-weight: bold;
//     text-transform: uppercase;
//     width: 100%;
//   }

//   textarea {
//     display: block;
//     border: 1px solid #ddd;
//     border-radius: 4px;
//     color: #444;
//     font-size: 16px;
//     padding: 14px 15px;
//     width: 100%;
//     resize: none;

//     &::placeholder {
//       color: #999;
//     }
//   }

//   span.error {
//     font-size: 11px;
//     font-weight: bold;
//     color: #de3b3b;
//     padding-top: 2px;
//   }
// `;

// export const FormContent = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
// `;

export const CheckWrapper = styled.div`
  padding: 10px 0;

  label {
    display: flex;
    align-items: center;
    color: #4a5b72;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    input {
      margin-right: 7px;
      accent-color: #ff6d3c;
    }
  }

  span.error {
    ${fieldError}
  }
`;

export const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  width: 100%;
  max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};

  label {
    ${fieldLabel}
  }

  textarea {
    display: block;
    width: 100%;
    padding: 13px 15px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 12px;
    background: #f8fafc;
    color: #1f2f46;
    font-size: 15px;
    line-height: 1.55;
    resize: none;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease,
      background 0.2s ease;

    &::placeholder {
      color: #98a5b7;
    }

    &:hover:not(:focus) {
      border-color: rgba(255, 109, 60, 0.4);
      background: #fff;
    }

    &:focus {
      border-color: #ff6d3c;
      background: #fff;
      box-shadow: 0 0 0 4px rgba(255, 109, 60, 0.12);
    }
  }

  span.error {
    ${fieldError}
  }
`;

export const FormContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
